import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from '../toast';
import { BreadcrumbsModule } from '../breadcrumbs';

import { SideNavMenuItemComponent } from './side-nav-menu-item';
import { SideNavHeaderComponent } from './side-nav-header';
import { SideNavFooterComponent, SideNavFooterService } from './side-nav-footer';
import { SideNavContainerComponent } from './side-nav-container';
import { SideNavComponent } from './side-nav';

@NgModule({
  exports: [
    SideNavContainerComponent,
    SideNavComponent,
    SideNavMenuItemComponent,
    SideNavFooterComponent,
    SideNavHeaderComponent,
  ],
  imports: [
    CommonModule,
    ToastModule,
    BreadcrumbsModule,
    SideNavComponent,
    SideNavContainerComponent,
    SideNavMenuItemComponent,
    SideNavFooterComponent,
    SideNavHeaderComponent ],
})
export class SideNavModule {
  public static forRoot(): ModuleWithProviders<SideNavModule> {
    return {
      ngModule: SideNavModule,
      providers: [
        SideNavFooterService,
      ],
    };
  }
}
